exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".builder-container[data-v-3f1e2143]{display:grid;gap:10px 10px;grid-template-columns:1fr}[data-v-3f1e2143] .builder-bottom-right{margin-top:20px;grid-column-end:-1;justify-self:end;align-self:end}\n", ""]);

